'use client';
import { useIsDesktop } from '@/_hooks/useBreakpoint';

import OrderDesktop from './responsive/desktop';
import Mobile from './responsive/mobile';

const Wrapper = () => {
  const isDesktop = useIsDesktop();

  return isDesktop ? <OrderDesktop /> : <Mobile />;
};

export default Wrapper;
